module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui fluid container black hero",
    attrs: {
      "id": "landing"
    }
  }, [_c('div', {
    staticClass: "ui stackable center aligned grid"
  }, [_c('div', {
    staticClass: "six wide left aligned middle aligned column"
  }, [_c('h1', {
    staticClass: "ui inverted header"
  }, [_vm._v("\n        Try the Aragon dapp\n        "), _c('div', {
    staticClass: "ui hidden half divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "sub header"
  }, [_vm._v("Create value without borders or intermediaries")])]), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('a', {
    staticClass: "ui huge aragon gradient button downloadButton",
    attrs: {
      "href": "https://github.com/AragonOne/aragon/releases/",
      "target": "_blank"
    }
  }, [_vm._v("Download Aragon Alpha")]), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('span', {
    staticClass: "white text",
    attrs: {
      "id": "weburl"
    }
  }, [_vm._v("or try out the "), _c('a', {
    attrs: {
      "href": "https://alpha.aragon.one",
      "target": "_blank"
    }
  }, [_vm._v("web version")])])]), _vm._v(" "), _c('div', {
    staticClass: "six wide column"
  }, [_c('div', {
    staticClass: "ui container"
  }, [_c('img', {
    staticClass: "ui fluid image",
    attrs: {
      "src": "https://aragon.one/rsc/imgs/screenshot.png",
      "id": "screenshot"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c97eb9a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Core.vue
// module id = 518
// module chunks = 1